import React, {useState, useEffect, useCallback} from 'react';
import {setProjectDragging} from 'actions/index.js';
import {getWallpapers} from 'decentralized/settings/appearance.js';
import WorkMetadata from './WorkMetadata.js';
import PitchClock from 'components/apps/PitchClock.js';
import ProgressBar from 'components/progressbar/ProgressBar.js';
import {setExploreWork} from 'actions/index.js';
import {playWork} from 'engine/mix/actions.js';
import SubSequenceButtons from './SubSequenceButtons.js';
import ethereum from 'decentralized/ethereum.js';
import Colors from 'components/Colors.js';
import PatternButtons from 'components/user/PatternButtons.js';
import {connect} from 'react-redux';
import PlayButton from 'components/user/PlayButton.js';
import WorkVolume from './WorkVolume.js';
import TransposeKnob from '../mixer/TransposeKnob.js';
import ColorKnob from '../mixer/ColorKnob.js';

const colors = new Colors();

const WorkMixer = ({
    workNumber,
    work,
    sequencerEngine,
    isLoading,
    isPlaying,
    unloadWork,
    setExploreWork,
    isAnnotationShowing,
    setProjectDragging
}) => {
    const [author, setAuthor] = useState('');
    const _sequencerEngine = sequencerEngine.idToSequencerEngine[work.newSequence];

    const [title, setTitle] = useState(work.title);
    const [thumbnail, setThumbnail ] = useState(undefined);

    useEffect(() => {
        if (work.guildId) {
            ethereum.guildSequences._decryptQueryResult(work)
                .then(s => setTitle(s.title));
        }
    }, [work, setTitle]);

    useEffect(() => {
        if (_sequencerEngine && _sequencerEngine._wallpaper) {
            getWallpapers(_sequencerEngine._wallpaper).then(
                results => {
                    if (results && results[0]) {
                        setThumbnail(results[0].thumbnail);
                    }
                }
            );
        }

    }, _sequencerEngine && _sequencerEngine._wallpaper);

    useEffect(() => {
        ethereum.users.getUserName(work.user)
            .then((userName) => setAuthor(userName));
    }, [work]);

    const playClicked = () => {
        let _work = {
            ... work,
            id: work.newSequence
        };
        sequencerEngine.dispatch(
            playWork(_work));
    };

    if (isLoading || !_sequencerEngine) {
        return (
            <div className="work-mixer loading">
              <ProgressBar width={200} id={work.newSequence}/>
              <div onClick={unloadWork} className="delete-button">x</div>
            </div>
        );
    }

    let titleColor = colors.getColorForHash(work.newSequence);
    let playStyle = {
        backgroundColor: titleColor
    };

    work.workNumber = workNumber;
    let style = {
    };
    let innerStyle = {};
    if (thumbnail) {
        innerStyle.backgroundImage = 'url(/ipfs/' + thumbnail + ')';
    }
    return (
        <div
          className="work-mixer-container">
          <div
            style={style} className="work-mixer">
            <div
              style={innerStyle} className="inner">
              <WorkVolume
                multiSequencerEngine={sequencerEngine}
                sequencerEngine={_sequencerEngine} id={work.newSequence}/>
              <div className="work-fields">
                <SubSequenceButtons sequencerEngine={_sequencerEngine}/>
                <PatternButtons
                  color={titleColor}
                  sequencerEngine={_sequencerEngine}/>
                <div className="cassette">
                  <TransposeKnob id={work.newSequence} sequencerEngine={_sequencerEngine}/>
                  <ColorKnob
                    mixEffects={_sequencerEngine.channelMixer.mixEffects}
                    sequencerEngine={_sequencerEngine}
                    id={work.newSequence}/>
                </div>
              </div>
            </div>
            <div
              draggable={true}
              onDragStart={() => setProjectDragging(work)}
              onDragOver={(e) => e.preventDefault()}
              className="bottom">
              <div
                style={playStyle}
                className="play-button">
                <PlayButton color={colors.getColorForHash(work.newSequence)} isPlaying={isPlaying} play={playClicked}/>
              </div>
              <div
                className="title">
                <div className="work-title">
                  {title}
                </div>
                <div className="author-divider">
                  -
                </div>
                <div className="work-author">
                  <div className="author-label">
                    Author
                  </div>
                  <div className="author-name">
                    {author}
                  </div>
                </div>
              </div>
              <img
                onClick={() => setExploreWork(isAnnotationShowing ? undefined : work)}
                src="/annotations.png"
                className={isAnnotationShowing ? "annotation-button showing" : "annotation-button"}/>
              <div
                style={playStyle}
                onClick={() => {setExploreWork(undefined); unloadWork();}} className="delete-button">x</div>
            </div>
            <WorkMetadata work={work}/>
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        isLoading: state.sequencer.loadingSequence[props.work.newSequence],
        isPlaying: state.sequencer.isPlaying[props.work.newSequence],
        isAnnotationShowing : state.explore.exploreWork === props.work,
        worksLoaded: state.explore.worksLoaded
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setExploreWork: (work) => dispatch(setExploreWork(work)),
        setProjectDragging: (x) => dispatch(setProjectDragging(x))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkMixer);
